<template>
  <pop-up
    id="pop-up-delete-container"
    is-warning
    title="Delete OEE Item"
    left-button="Cancel"
    right-button="Yes, Delete"
    :active="active"
    @update:active="$emit('update:active', $event)"
    @close="onClose()"
    @leftButton="onClose()"
    @rightButton="onHandleDelete()"
  >
    <p class="text-center mt-1">
      Are you sure you want to delete {{ data.level }} item "{{ data.name }}"?
    </p>
    <p class="text-center">
      All sub-levels items will also be deleted and cannot be undone.
    </p>
  </pop-up>
</template>

<script>
import { debounce } from 'lodash'

import PopUp from '@/components/popUp'

export default {
  components: {
    PopUp
  },
  props: {
    active: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Object,
      default: () => null
    }
  },
  watch: {
    isLoading: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.$vs.loading({
            type: 'radius',
            color: 'primary',
            container: '#pop-up-delete-container',
            scale: 0.5
          })

          return
        }

        this.$vs.loading.close('#pop-up-delete-container > .con-vs-loading')
      }
    }
  },
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    fetch: debounce(function () {
      this.$emit('fetch')
    }, 500),
    async onHandleDelete() {
      this.isLoading = true

      try {
        if (!!this.data && !!this.data.id) {
          await this.$store.dispatch('OEEItemsManagement/deleteOEEItem', this.data.id)
          this.showSuccessNotification(this, `OEE Item ${this.data.level} successfully deleted.`)

          this.fetch()
          const onCloseDebounce = debounce(() => {
            this.onClose()
          }, 500)
          onCloseDebounce()
        }
      } catch (error) {
        this.isLoading = false
        const message = error?.errors?.[0]?.[0]?.message || error?.message || 'Failed to delete, please try again'

        this.showFailedNotification(this, message, 'Error')
      }
    },
    onClose() {
      this.isLoading = false
      this.$emit('update:active', false)
    }
  }
}
</script>

<style scoped lang="scss">

</style>